export const createLocationTags = ({ country, city }) => {
  let tags = [country === 'Remote' || city === 'Remote' ? 'Remote' : 'Hybrid']
  if (country && country !== 'Remote') tags.push(country)
  if (city && city !== 'Remote' && country !== 'Remote') tags.push(city)
  return tags
}
